import { LoginForm, type RequestCodeOutcome, type VerifyCodeOutcome } from "@teamtable/portal-ui";
import { useLocation } from "wouter";

import { apiClient } from "../api/client.js";
import { useAuth } from "../auth/AuthContext.js";

export function Login({ returnTo }: { returnTo?: string }) {
  const [, navigate] = useLocation();
  const { refresh } = useAuth();

  async function requestCode(email: string): Promise<RequestCodeOutcome> {
    try {
      const res = await apiClient["/api/v1/venue/auth/request-code"]["post"]({
        parameters: {},
        body: { email },
      });
      // The client hands back undeclared status codes verbatim rather than
      // throwing, so every status is named here and anything unnamed is a
      // server fault, not a bad address.
      if (res.code === 200) return "sent";
      if (res.code === 400) return "invalid-email";
      if (res.code === 429) return "throttled";
      return "error";
    } catch {
      return "error";
    }
  }

  async function verifyCode(email: string, code: string): Promise<VerifyCodeOutcome> {
    try {
      const res = await apiClient["/api/v1/venue/auth/verify-code"]["post"]({
        parameters: {},
        body: { email, code },
      });
      if (res.code === 401) return "invalid";
      if (res.code !== 200) return "error";
      await refresh();
      navigate(returnTo ?? "/");
      return "ok";
    } catch {
      return "error";
    }
  }

  return (
    <LoginForm
      title="TeamTable Venue"
      subtitle="Sign in to manage your venue."
      onRequestCode={requestCode}
      onVerifyCode={verifyCode}
    />
  );
}
